import useGradesTableStore from '../store/useGradesTableStore';
import isAwaitingData from './queries/isAwaitingData';
import useAssessments from './queries/useAssessments';
import useClassroom from './queries/useClassroom';
import useClassroomLesson from './queries/useClassroomLesson';
import useLessonGames from './queries/useLessonGames';
import useProgramAccess from './queries/useProgramAccess';
import useReadingGames from './queries/useReadingGames';
import useReferenceMaterials from './queries/useReferenceMaterials';
import useScorableNotebooks from './queries/useScorableNotebooks';
import useSectionAssignments from './queries/useSectionAssignments';
import useSlideShows from './queries/useSlideShows';
import useStudents from './queries/useStudents';
import useUnitProjects from './queries/useUnitProjects';
import useVideoActivity from './queries/useVideoActivity';

// AIDEV-NOTE: structural = any query that changes which rows or columns exist. Score queries
// (exerciseResults/, questionAnswers/) must stay out, or cells can never skeleton independently.
// useSlideShowColumns and useReferenceMaterialColumns memoize on [] and are safe only because
// their feeds are listed here — resolved before <Table /> ever mounts.
const useIsStructureLoading = () => {
  const classroom = useGradesTableStore(state => state.classroom);
  const lesson = useGradesTableStore(state => state.lesson);

  return isAwaitingData(
    useStudents(classroom?.id),
    useClassroom(),
    useClassroomLesson(classroom?.id, lesson?.id),
    useAssessments(classroom?.id, lesson?.id),
    useSlideShows(classroom?.id, lesson?.id),
    useReferenceMaterials(classroom?.id, lesson?.id),
    useVideoActivity(classroom?.id, lesson?.id),
    useScorableNotebooks(),
    useSectionAssignments(),
    useLessonGames(),
    useReadingGames(lesson?.id),
    useProgramAccess(),
    useUnitProjects(),
  );
};

export default useIsStructureLoading;
